/**
 * @packageDocumentation
 * @module      EmcEnums.ts
 * @description Holds all enums related to EMC.
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
export var EmcSection;
(function (EmcSection) {
    EmcSection[EmcSection["None"] = 0] = "None";
    EmcSection[EmcSection["systemStatus"] = 1] = "systemStatus";
    EmcSection[EmcSection["testOptions"] = 2] = "testOptions";
    EmcSection[EmcSection["armSubSystem"] = 3] = "armSubSystem";
    EmcSection[EmcSection["driveSubSystem"] = 4] = "driveSubSystem";
    EmcSection[EmcSection["csPdoSubSystem"] = 5] = "csPdoSubSystem";
    EmcSection[EmcSection["psPdoSubSystem"] = 6] = "psPdoSubSystem";
    EmcSection[EmcSection["patientSoftwareVersion"] = 7] = "patientSoftwareVersion";
    EmcSection[EmcSection["controlSoftwareVersion"] = 8] = "controlSoftwareVersion";
    EmcSection[EmcSection["pimData"] = 9] = "pimData";
    EmcSection[EmcSection["RcData"] = 10] = "RcData";
})(EmcSection || (EmcSection = {}));
export var initialState;
(function (initialState) {
    initialState[initialState["IdleMonitor"] = 0] = "IdleMonitor";
    initialState[initialState["EMCAutomation"] = 1] = "EMCAutomation";
    initialState[initialState["IdleMonitorFallBack"] = 2] = "IdleMonitorFallBack";
})(initialState || (initialState = {}));
export var driveMod;
(function (driveMod) {
    driveMod[driveMod["driveModule1"] = 1] = "driveModule1";
    driveMod[driveMod["driveModule2"] = 2] = "driveModule2";
    driveMod[driveMod["driveModule3"] = 3] = "driveModule3";
    driveMod[driveMod["driveModule4"] = 4] = "driveModule4";
})(driveMod || (driveMod = {}));
export var armMod;
(function (armMod) {
    armMod[armMod["armModule1"] = 5] = "armModule1";
    armMod[armMod["armModule2"] = 6] = "armModule2";
})(armMod || (armMod = {}));
export var FrameMod;
(function (FrameMod) {
    FrameMod[FrameMod["frameModule1"] = 7] = "frameModule1";
})(FrameMod || (FrameMod = {}));
export var Subsystems;
(function (Subsystems) {
    Subsystems["ArmLock"] = "ArmLock";
})(Subsystems || (Subsystems = {}));
export var EmcFaultSeverity;
(function (EmcFaultSeverity) {
    EmcFaultSeverity["CLEARED"] = "CLEARED";
    EmcFaultSeverity["WARNING"] = "WARNING";
    EmcFaultSeverity["FAULT"] = "FAULT";
})(EmcFaultSeverity || (EmcFaultSeverity = {}));
//# sourceMappingURL=EmcEnums.js.map